var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "report" },
        [
          _c("page-title-secondary", { attrs: { title: "提交漏洞" } }),
          _vm._v(" "),
          _c("div", { staticClass: "report__content" }, [
            _c(
              "div",
              { staticClass: "report__form" },
              [
                _c(
                  "xui-form",
                  {
                    ref: "ruleForm",
                    attrs: { model: _vm.ruleForm, rules: _vm.rules }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "report__form-row--one" },
                      [
                        _c(
                          "div",
                          { staticClass: "xui-form-item__label is-required" },
                          [_vm._v("漏洞名称")]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-form-item",
                          {
                            ref: "ruleFormName",
                            attrs: { label: "", prop: "vulTitle" }
                          },
                          [
                            _c("xui-input", {
                              attrs: {
                                placeholder: "请输入漏洞名称，特殊字符除外"
                              },
                              model: {
                                value: _vm.ruleForm.vulTitle,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "vulTitle",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "ruleForm.vulTitle"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "report__form-row--two" },
                      [
                        _c(
                          "div",
                          { staticClass: "xui-form-item__label is-required" },
                          [_vm._v("漏洞类型")]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-form-item",
                          { attrs: { label: "", prop: "vulTypeId" } },
                          [
                            _c(
                              "xui-select",
                              {
                                attrs: { placeholder: "请选择漏洞类型" },
                                on: { change: _vm.changeVulType },
                                model: {
                                  value: _vm.ruleForm.vulTypeId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "vulTypeId",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.vulTypeId"
                                }
                              },
                              _vm._l(_vm.vulTypeOption, function(item) {
                                return _c("xui-option", {
                                  key: item.itemCode,
                                  staticClass: "item-dropdown",
                                  attrs: {
                                    label: item.itemName,
                                    value: item.itemCode
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-form-item",
                          {
                            staticClass: "second-item",
                            attrs: { prop: "vulSubtypeId" }
                          },
                          [
                            _c(
                              "xui-select",
                              {
                                attrs: { placeholder: "请选择漏洞类型" },
                                model: {
                                  value: _vm.ruleForm.vulSubtypeId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "vulSubtypeId",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.vulSubtypeId"
                                }
                              },
                              _vm._l(_vm.vulSubTypeOption, function(item) {
                                return _c("xui-option", {
                                  key: item.itemCode,
                                  staticClass: "item-dropdown",
                                  attrs: {
                                    label: item.itemName,
                                    value: item.itemCode
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "report__form-row--two" },
                      [
                        _c(
                          "div",
                          { staticClass: "xui-form-item__label is-required" },
                          [_vm._v("所属业务")]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-form-item",
                          { attrs: { label: "", prop: "orgId" } },
                          [
                            _c(
                              "xui-select",
                              {
                                attrs: { placeholder: "请选择所属业务" },
                                on: { change: _vm.changeOrgId },
                                model: {
                                  value: _vm.ruleForm.orgId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "orgId",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.orgId"
                                }
                              },
                              _vm._l(_vm.orgIdOption, function(item) {
                                return _c("xui-option", {
                                  key: item.itemCode,
                                  staticClass: "item-dropdown",
                                  attrs: {
                                    label: item.itemName,
                                    value: item.itemCode
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-form-item",
                          {
                            staticClass: "second-item",
                            attrs: { prop: "productId" }
                          },
                          [
                            _c(
                              "xui-select",
                              {
                                attrs: { placeholder: "请选择所属业务" },
                                model: {
                                  value: _vm.ruleForm.productId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "productId",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.productId"
                                }
                              },
                              _vm._l(_vm.productIdOption, function(item) {
                                return _c("xui-option", {
                                  key: item.itemCode,
                                  staticClass: "item-dropdown",
                                  attrs: {
                                    label: item.itemName,
                                    value: item.itemCode
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "report__form-row--one" },
                      [
                        _c(
                          "div",
                          { staticClass: "xui-form-item__label is-required" },
                          [_vm._v("漏洞等级")]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-form-item",
                          { attrs: { label: "", prop: "vulLevel" } },
                          [
                            _c(
                              "xui-select",
                              {
                                attrs: { placeholder: "请选择漏洞等级" },
                                model: {
                                  value: _vm.ruleForm.vulLevel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "vulLevel",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "ruleForm.vulLevel"
                                }
                              },
                              _vm._l(_vm.levelOption, function(item) {
                                return _c("xui-option", {
                                  key: item.key,
                                  staticClass: "item-dropdown",
                                  attrs: { label: item.label, value: item.key }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "report__form-row--one" },
                      [
                        _c("div", { staticClass: "xui-form-item__label" }, [
                          _vm._v("漏洞URL")
                        ]),
                        _vm._v(" "),
                        _c(
                          "xui-form-item",
                          {
                            staticClass: "item-url",
                            attrs: { label: "", prop: "vulUrl" }
                          },
                          [
                            _c("xui-input", {
                              attrs: { placeholder: "请输入漏洞URL" },
                              model: {
                                value: _vm.ruleForm.vulUrl,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.ruleForm,
                                    "vulUrl",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "ruleForm.vulUrl"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "report__form-row--one" },
                      [
                        _c(
                          "div",
                          { staticClass: "xui-form-item__label is-required" },
                          [_vm._v("漏洞详情")]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-form-item",
                          { attrs: { label: "", prop: "content" } },
                          [
                            _c("quill-editor", {
                              ref: "QuillEditor",
                              staticClass: "report__quill-editor",
                              attrs: {
                                id: "quill_editor",
                                options: _vm.editorOption5
                              },
                              on: { change: _vm.changeEditor },
                              model: {
                                value: _vm.ruleForm.content,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "content", $$v)
                                },
                                expression: "ruleForm.content"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-upload",
                          {
                            staticClass: "report__form-upload",
                            staticStyle: { display: "none" },
                            attrs: {
                              action: _vm.actionImg,
                              "before-upload": _vm.beforUploadPic,
                              headers: _vm.xCsrfToken,
                              "on-error": _vm.reportError,
                              "show-overflow-tooltip": "",
                              "on-success": _vm.handlePreview,
                              multiple: "",
                              "with-credentials": true
                            }
                          },
                          [
                            _c(
                              "xui-button",
                              {
                                staticStyle: { display: "none" },
                                attrs: {
                                  id: "upload",
                                  size: "medium",
                                  icon: "fa fa-upload"
                                }
                              },
                              [_vm._v("上传")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "report__form-row--one" },
                      [
                        _c("div", { staticClass: "xui-form-item__label" }, [
                          _vm._v("上传附件")
                        ]),
                        _vm._v(" "),
                        _c(
                          "xui-form-item",
                          {
                            staticClass: "is-overflow-hidden",
                            attrs: { label: "", prop: "attachmentList" }
                          },
                          [
                            _c(
                              "xui-upload",
                              {
                                staticClass: "report__form-upload",
                                attrs: {
                                  action: _vm.actionZip,
                                  headers: _vm.xCsrfToken,
                                  limit: 1,
                                  "on-error": _vm.reportError,
                                  "show-overflow-tooltip": "",
                                  accept: ".zip,.7z,.rar",
                                  "on-remove": _vm.resetFile,
                                  "before-upload": _vm.beforUploadZip,
                                  "on-exceed": _vm.handleExceed,
                                  "file-list": _vm.ruleForm.fileList,
                                  "on-success": _vm.handlePreviewZip,
                                  "with-credentials": true
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "report__form-button--upload",
                                    attrs: {
                                      id: "uploadZip",
                                      href: "javascript:void(0);"
                                    }
                                  },
                                  [_vm._v("选择文件")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "report__form-tip--upload",
                                    attrs: { slot: "tip" },
                                    slot: "tip"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      格式限制:7z,rar,zip格式,不超过200M。 "
                                    ),
                                    _vm.uploadMsg
                                      ? _c(
                                          "span",
                                          { staticClass: "upload_msg-scan" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.uploadMsg) + " "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "report__form-row--one" },
                      [
                        _c(
                          "div",
                          { staticClass: "xui-form-item__label is-required" },
                          [_vm._v("完成验证")]
                        ),
                        _vm._v(" "),
                        _c(
                          "xui-form-item",
                          { staticClass: "is-required", attrs: { label: "" } },
                          [
                            _c("div", {
                              ref: "captcha",
                              attrs: { id: "captcha" }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("xui-form-item", [
                      _c(
                        "div",
                        { staticClass: "report__form-button--summary" },
                        [_vm._v("在漏洞未修复之前，请不要向外界传播")]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "report__form-row--submit" },
                      [
                        _c(
                          "xui-button",
                          {
                            staticClass: "report__form-button--submit",
                            attrs: { disabled: _vm.submitDisabled },
                            on: {
                              click: function($event) {
                                return _vm.submitForm("ruleForm")
                              }
                            }
                          },
                          [_vm._v("提交漏洞")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report__program" }, [
              _c("div", { staticClass: "report__program-title" }, [
                _vm._v("各奖励计划漏洞评分规则：")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "program-valid-list" }, [
                _c(
                  "ul",
                  _vm._l(_vm.rewardData, function(it) {
                    return _c(
                      "li",
                      { key: it.title, staticClass: "program-valid-item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "report__program-link",
                            attrs: {
                              to: {
                                path: "/program/detail",
                                query: { code: it.announcementId }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(it.title) +
                                "\n                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          staticClass: "warnning-wrap",
          attrs: {
            title: "",
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.dialogVisible,
            width: _vm.$store.state.isMobile ? "80%" : "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "h3",
            {
              style: {
                "font-size": _vm.$store.state.isMobile ? "24px" : "16.5px"
              }
            },
            [_vm._v("荣耀安全应急响应中心服务条款")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrap",
              style: {
                "font-size": _vm.$store.state.isMobile ? "22px" : "14px"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:"
                )
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [_vm._v("真实姓名，身份证正反面照片及身份证号；")]),
                _vm._v(" "),
                _c("li", [_vm._v("银行卡号，开户行信息，银行名称；")]),
                _vm._v(" "),
                _c("li", [_vm._v("手机号码，邮寄地址；")]),
                _vm._v(" "),
                _c("li", [_vm._v("昵称，头像，邮箱，主页；")]),
                _vm._v(" "),
                _c("li", [_vm._v("QQ，微信，签名，团队；")]),
                _vm._v(" "),
                _c("li", [_vm._v("IP地址；")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "上述数据将会传输并保存至位于中华人民共和国境内的服务器。"
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v("点击“同意”，即表示您同意\n        "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-user-protocol",
                    attrs: { href: _vm.safetyURL, target: "_blank" }
                  },
                  [_vm._v("荣耀安全应急响应中心用户协议")]
                ),
                _vm._v("\n        ，并知悉\n        "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-secret-statement",
                    attrs: { href: _vm.privacyURL, target: "_blank" }
                  },
                  [_vm._v("关于安全应急响应中心与隐私的声明")]
                ),
                _vm._v("。")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer", center: "" }, slot: "footer" },
            [
              _c(
                "xui-button",
                { attrs: { size: "bigger" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "xui-button",
                {
                  attrs: { type: "primary", size: "bigger" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("同意")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          staticClass: "submit-wrap",
          attrs: {
            title: "",
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.submitSuccess,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.submitSuccess = $event
            },
            close: _vm.resetThePage
          }
        },
        [
          _c("div", { staticClass: "dia-body" }, [
            _c(
              "div",
              { staticClass: "img-and-title" },
              [
                _vm.success
                  ? [
                      _c("img", {
                        staticClass: "img-success",
                        attrs: {
                          src: require("../../images/settingSuccess.jpg")
                        }
                      })
                    ]
                  : [
                      _c("img", {
                        staticClass: "img-success",
                        attrs: { src: require("../../images/settingError.png") }
                      })
                    ],
                _vm._v(" "),
                _c("span", { staticClass: "report-tip-title" }, [
                  _vm._v("漏洞提交成功")
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.complete,
                    expression: "complete"
                  }
                ],
                staticClass: "dialog__body"
              },
              [
                _c("div", { staticClass: "report-tip" }, [
                  _c("i", { staticClass: "fa fa-engine-warning" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("您还未完善您的个人信息")])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "建议您在收到漏洞奖金支付消息通知时，及时完善您的身份认证资料，便于及时支付漏洞奖金。"
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.complete,
                  expression: "complete"
                }
              ],
              staticClass: "dialog-footer",
              attrs: { slot: "footer", center: "" },
              slot: "footer"
            },
            [
              _c(
                "xui-button",
                {
                  staticClass: "left",
                  attrs: { type: "primary", size: "bigger" },
                  on: { click: _vm.toIdInfo }
                },
                [_vm._v("完善个人信息")]
              ),
              _vm._v(" "),
              _c(
                "xui-button",
                {
                  staticClass: "right",
                  attrs: { size: "bigger" },
                  on: { click: _vm.resetThePage }
                },
                [_vm._v("以后再说")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isNotLogin && _vm.isEffect
        ? _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "失效提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("您的账号已经失效，请联系管理员")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.handleClose }
                    },
                    [_vm._v("返回首页")]
                  )
                ],
                1
              )
            ]
          )
        : _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "登录提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("系统检测到您未登录或登录失效，请先登录")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.login }
                    },
                    [_vm._v("荣耀账号登录")]
                  )
                ],
                1
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b76b1936", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b76b1936","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/Report.vue
// module id = null
// module chunks = 